import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LocationModel } from "src/app/location/location";
import { Subscription } from "rxjs";
import { MatSnackBar } from "@angular/material";
import { LocationService } from "src/app/location/location.service";
import { AuthService } from "src/app/auth.service";
import { NgForm } from "@angular/forms";

@Component({
  selector: "app-location-form",
  templateUrl: "./location-form.component.html",
  styleUrls: ["./location-form.component.css"],
})
export class LocationFormComponent implements OnInit, OnDestroy {
  @ViewChild("locationForm") locationForm: NgForm;

  private subscription$ = new Subscription();
  showLoader: boolean = false;
  contractor_id: number;
  color = "primary";
  mode = "determinate";
  bufferValue = 75;
  fieldArray: string[] = [];
  progresBarValue: number;

  location: LocationModel;
  constructor(
    private locationService: LocationService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private el: ElementRef
  ) {
    this.location = new LocationModel();
  }
  ngOnInit(): void { }

  /**
   * Saving Location
   */
  save() {
    this.showLoader = true;
    this.location.c = this.authService.getContractorInfo().contractor_id;
    this.subscription$.add(
      this.locationService.addNewLocation(this.location).subscribe(
        () => {
          this.showLoader = false;
          this.router.navigate(["/locations"]);
          this.snackBar.open(`${"Location Created Sucessfully"} `, "", {
            duration: 2000,
          });
        },
        (error) => {
          this.showLoader = false;
          this.snackBar.open(`${"Error in Creating Location"}`, "", {
            duration: 2000,
          });
        }
      )
    );
  }
/**
   * validate input fields and show progress bar
   */

  validateInputs() {
    let inputCount = 0;
    Object.keys(this.locationForm.controls).map((field) => {
      if (this.locationForm.controls[field].valid) inputCount++;
    });

    this.progresBarValue =
      (inputCount / Object.keys(this.locationForm.controls).length) * 100;
  }
/**
 * unsubscribe the subscriptions
 */
  ngOnDestroy() {
    this.subscription$.unsubscribe();
  }
}
